export const COLOR_LIST = [
  '#2A76E8',
  '#19AEF5',
  '#3852DD',
  '#4681FF',
  '#088CE6',
  '#4958EB',
]
export const LIMIT = 20
export const SUBJECT_COUNT = 3


// WEBPACK FOOTER //
// ./src/pages/constants.js